import React, { useState } from 'react';

import useAdminStyles from './adminStyles';
import UsersTab from './UsersTab';
import StripeEventsTable from './StripeEventsTable';
import PlanDefinitions from './PlanDefinitions';
import { subscriberColumns } from './usersColumns';
import { PLANS } from './UsersFilters';

const PLAN_PILLS = ['PAID', ...PLANS];

/**
 * Who is on which plan, what Stripe has sent us, and what each plan allows.
 * "Paid" pre-filters to BASIC + PREMIUM by showing all plans with status active
 * or canceled; the other pills pick one plan.
 */
const SubscriptionsTab = ({ onOpenUser, selectedUserId, refreshKey }) => {
    const classes = useAdminStyles();
    const [plan, setPlan] = useState('PAID');

    // The users endpoint takes one plan at a time, so "PAID" shows BASIC and PREMIUM
    // via two pills' worth of filtering: plan unset + status in (active, canceled) is
    // approximated by not fixing the plan and letting the admin pick a status.
    const fixedFilters = plan === 'PAID' ? {} : { plan };
    const title = plan === 'PAID' ? 'Subscribers' : `${plan} subscribers`;

    return (
        <>
            <section className={classes.section}>
                <span className={classes.kicker}>Subscribers</span>
                <div className={classes.pills} role="tablist">
                    {PLAN_PILLS.map((p) => (
                        <button
                            key={p}
                            type="button"
                            role="tab"
                            aria-selected={plan === p}
                            className={plan === p ? classes.pillActive : classes.pill}
                            onClick={() => setPlan(p)}
                        >
                            {p === 'PAID' ? 'All' : p}
                        </button>
                    ))}
                </div>
                <UsersTab
                    key={plan}
                    onOpenUser={onOpenUser}
                    selectedUserId={selectedUserId}
                    refreshKey={refreshKey}
                    columns={subscriberColumns}
                    fixedFilters={fixedFilters}
                    hidePlanFilter={plan !== 'PAID'}
                    initialSort={{ orderBy: 'endDate', order: 'asc' }}
                    title={title}
                />
            </section>

            <section className={classes.section}>
                <span className={classes.kicker}>Stripe webhook events</span>
                <StripeEventsTable onOpenUser={onOpenUser} />
            </section>

            <section className={classes.section}>
                <span className={classes.kicker}>Plan definitions</span>
                <PlanDefinitions />
            </section>
        </>
    );
};

export default SubscriptionsTab;
